<div class="loader app-loader proj-section" [hidden]="status != STATUS_LOADING">
    <div class="dimmed_outset">
      <core-title-section [title]="'PROJECT <small>(# . . .)</small>'"></core-title-section>
    </div>
  <div class="dimmed dimmed_main" >
    <div class="dimmed_nav">
      <div class="dimmed_subtitle"></div>
      <div class="dimmed_subtitle"></div>
      <div class="dimmed_subtitle"></div>
    </div>
    <div class="dimmed_content">
      <div class="dimmed_flex">
        <span class="dimmed_tag"></span>
        <span class="dimmed_tag"></span>
        <span class="dimmed_tag"></span>
      </div>
    </div>
  </div>
</div>



  <div class="app-wrapper " *ngIf="status == STATUS_DONE || status == STATUS_NOT_ACCESS_DONE">
    <nav class="tab_navigation">
      <!-- &nbsp; -->
      <core-helpers-navigation-vertical-tabs [hidden]="projectHeader != null || status == STATUS_NOT_ACCESS_DONE" [menu]="menuProjects"></core-helpers-navigation-vertical-tabs>
    </nav>
    <section class="main-content project-details-section">
      <div class="content-info-main">
        <div *ngIf="status == STATUS_DONE" class="layout-main">
          <!-- here will load each part of project details -->
          <router-outlet></router-outlet>
        </div>
        <div *ngIf="status == STATUS_NOT_ACCESS_DONE">
          <project-details-forbidden-header-main *ngIf="projectHeader != null" [projectHeader]="projectHeader"></project-details-forbidden-header-main>
            <div class="loader proj-section-nested" [hidden]="projectHeader != null">
            <div class="dimmed_outset">
              <core-title-section [title]="'PROJECT <small>(# . . .)</small>'"></core-title-section>
            </div>
            <div class="dimmed dimmed_main">
              <div class="dimmed_content">
                <div class="dimmed_flex">
                  <span class="dimmed_tag"></span>
                  <span class="dimmed_tag"></span>
                  <span class="dimmed_tag"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- not needed beacuse we have a component to show minimal data of the project -->
<!-- <core-helpers-box-http-error
    *ngIf="status == STATUS_NOT_ACCESS_DONE"
    [code]="403"
    [message]="'Not allowed.'"
></core-helpers-box-http-error> -->

<core-helpers-box-http-error
    *ngIf="status == STATUS_NOT_FOUND"
    [code]="404"
    [message]="'Not found.'"
></core-helpers-box-http-error>

<core-helpers-box-http-error
    *ngIf="status == STATUS_ERROR"
    [code]="500"
    [message]="'Error.'"
></core-helpers-box-http-error>
